import { Card } from '../../components/Card';
import { DocumentPagesClassificationChart } from '../../components/DocumentPagesClassificationChart';
import type { CategoryResponse } from './types';

export function CategoryPageChart({ response }: { response: CategoryResponse }) {
  if (!response?.pages) {
    return null;
  }

  return (
    <Card
      header={<h2 className="text-lg font-semibold text-gray-900 dark:text-zinc-100">Category Page Classification</h2>}
    >
      <div className={`w-full min-h-[300px]`}>
        <DocumentPagesClassificationChart
          pages={response.pages}
          onPageClick={(page) => {
            const pageIndex = response.pages.findIndex((p) => p.id === page.id);
            if (pageIndex !== -1) {
              window.open(`/document-pages/${page.id}`, '_blank');
            }
          }}
        />
      </div>
    </Card>
  );
}
